<template>
    <div class="flex">
    <div class="relative group">
        <svg
            viewBox="0 0 100 100"
            class="w-10 h-10 fill-gold"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M10 54 L50 94 L90 54 Z"/>

            <path d="M10 48 L28 20 L45 48 Z"/>

            <path d="M34 20 L66 20 L50 48 Z"/>

            <path d="M55 48 L72 20 L90 48 Z"/>
        </svg>
    </div>

    <div class="flex flex-col">
        <span class="text-3xl md:text-3xl font-black tracking-tight font-cairo"
              :class="props.textColor"
        >الصائغ
        </span>
    </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
    textColor: {default: 'text-white'}
})
</script>
